import React, { useEffect, useState } from "react";

interface FancyAnimatePointProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: number;
  oscillate?: boolean;
}

const FancyAnimatePoint: React.FC<FancyAnimatePointProps> = ({
  size = 10,
  oscillate = true,
  className,
  ...props
}) => {
  const [pressed, setPressed] = useState(false);

  const normalShadow = `
    inset 0px -2px 6px rgba(0, 0, 0, 0.1),
    inset -2px 0px 4px rgba(255, 255, 255, 0.3),
    inset 2px 0px 4px rgba(0, 0, 0, 0.3),
    inset 0px -6px 4px rgba(0, 0, 0, 0.1),
    inset 0px 6px 4px rgba(255, 255, 255, 0.3)
  `;

  const pressedShadow = `
    inset 0px -1px 3px rgba(0, 0, 0, 0.1),
    inset -1px 0px 2px rgba(255, 255, 255, 0.3),
    inset 1px 0px 2px rgba(0, 0, 0, 0.3),
    inset 0px -3px 2px rgba(0, 0, 0, 0.1),
    inset 0px 3px 2px rgba(255, 255, 255, 0.3)
  `;

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes inspirationNavbarOscillate {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.2); }
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: "50%",
        backgroundColor: "#222",
        boxShadow: pressed ? pressedShadow : normalShadow,
        cursor: "pointer",
        display: "inline-block",
        willChange: "transform, box-shadow",
        touchAction: "manipulation",
        userSelect: "none",
        animation:
          pressed || !oscillate ? "none" : "inspirationNavbarOscillate 2s ease-in-out infinite",
        transform: pressed ? "scale(0.9)" : undefined,
      }}
      className={className}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      onMouseLeave={() => setPressed(false)}
      onTouchStart={() => setPressed(true)}
      onTouchEnd={() => setTimeout(() => setPressed(false), 100)}
      {...props}
    />
  );
};

export default FancyAnimatePoint;
